<script setup>
import { Link } from '@inertiajs/vue3';

defineProps({
    href: String,
    type: String,
});
</script>

<template>
    <div>
        <button v-if="type == 'button'" type="submit" class="block w-full px-4 py-2 text-sm leading-5 text-gray-700 text-left hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition">
            <slot />
        </button>

        <a v-else-if="type == 'a'" :href="href" class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition" target="_blank">
            <slot />
        </a>

        <Link v-else :href="href" class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition">
        <slot />
        </Link>
    </div>
</template>
